import { API_PREFIX } from '../../../util/apiPrefix';

const VITE_API_URL = import.meta.env.VITE_API_URL ?? '';
const VITE_API_SELF_PING = import.meta.env.VITE_API_SELF_PING;

export const SELF_PING_URL = `${VITE_API_URL}${API_PREFIX}${VITE_API_SELF_PING}`;

export const PING_INTERVAL = 120000;
